import React from 'react';
import { useSelector } from 'react-redux';
import { useFetch } from 'bv-hooks';
import { selectLoggedIn } from 'session-selectors';
import fetchLeftComponents from './api/fetch_left_components';
import LeftComponentsView from './left_components_view';

export default () => {
  const loggedIn = useSelector(selectLoggedIn);
  const [components, loading] = useFetch(fetchLeftComponents, [loggedIn]);

  return <LeftComponentsView components={components} loading={loading} />;
};
